interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: string
  children?: React.ReactNode
}

const Badge = ({ children, variant = 'gray', className = '', ...props }: BadgeProps) => {
  const variants: Record<string, string> = {
    success: 'badge-success',
    warning: 'badge-warning',
    danger: 'badge-danger',
    info: 'badge-info',
    gray: 'badge-gray',
    purple: 'bg-purple-100 text-purple-800 badge',
    default: 'badge-gray',
    destructive: 'badge-danger',
    secondary: 'badge-gray',
  }
  return <span className={`${variants[variant] || variants.gray} ${className}`} {...props}>{children}</span>
}

export default Badge
